import type {
  BillPaymentHistoryActivity,
  BillPaymentHistoryActivityType,
} from 'src/queries/payments/payments.types'

export type PaymentActivityState = 'completed' | 'current' | 'error'

interface PaymentActivityPresentation {
  label: string
  state: PaymentActivityState
}

const ACTIVITY_LABELS: Record<BillPaymentHistoryActivityType, string> = {
  CONFIRMED: 'Invoice Saved',
  AUTHORIZATION_REQUESTED: 'Authorization Requested',
  SCHEDULED: 'Payment Initiated',
  PROCESSING: 'Processing',
  REMITTANCE_EMAIL_SENT: 'Vendor Notified',
  COMPLETED: 'Paid',
  FAILED: 'Failed',
  RETURNED: 'Returned',
  CANCELLED: 'Cancelled',
}

const ERROR_ACTIVITY_TYPES: BillPaymentHistoryActivityType[] = [
  'FAILED',
  'RETURNED',
  'CANCELLED',
]

export const paymentActivityPresentation = (
  activity: BillPaymentHistoryActivity,
  isNewest: boolean,
): PaymentActivityPresentation => ({
  label: ACTIVITY_LABELS[activity.type],
  state: ERROR_ACTIVITY_TYPES.includes(activity.type)
    ? 'error'
    : isNewest && activity.type !== 'COMPLETED'
      ? 'current'
      : 'completed',
})
